import { Component, Input, ViewChild, ContentChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { ModalComponent } from 'ngx-boot-modal';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.css']
})
export class InfoModalComponent {
  @Input() title: string;
  @Input() titleParams: { [key: string]: any };
  @Input() message: string;
  @Input() messageParams: string | string [] = [];
  @Input() acceptLabel = 'shared.info.accept';
  @Input() cancelLabel = 'shared.info.cancel';
  @Input() hideHeaderIcon = false;
  @Input() modalClass = 'modal--confirmation';
  @Input() closeOnOutsideClick = true;
  @Input() showFooter = true;
  @Input() showCancel = false;
  @Input() hideCloseButton = true;
  @Input() acceptClass: string;
  @ViewChild(ModalComponent) modal: ModalComponent;
  @ContentChild('') content: ElementRef;
  @Output() accept = new EventEmitter();
  @Output() cancel = new EventEmitter();

  open() {
    this.modal.open();
  }

  close() {
    this.modal.close();
  }

  onAccept() {
    this.accept.emit();
    this.modal.close();
  }

  onCancel() {
    this.cancel.emit();
    this.modal.close();
  }

  get msgParams() {
    return (typeof this.messageParams === 'string') ? [this.messageParams] : this.messageParams;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/modals/info-modal/info-modal.component.ts